import type { SocialNetworks } from '@/types';

import React from 'react';

import LogoFooter from '../LogoFooter';
import SocialMedia from '../SocialMedia';
import { DynamicSymbol } from '../TitlesDesktop';

import { Box, Text } from '@/components';
import { useTranslation } from '@/hooks';

const TopSection: React.FC<{ socialNetworks: SocialNetworks }> = ({
  socialNetworks,
}) => {
  const { t } = useTranslation('components.footer');

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Box display={{ base: 'none', xl: 'block' }}>
        <LogoFooter />
      </Box>
      <Text color="text" fontSize="sm" mt="30px">
        {t('liateam')}
      </Text>
      <Box>
        <SocialMedia socialNetworks={socialNetworks} />
      </Box>
      <DynamicSymbol />
    </Box>
  );
};

export default TopSection;
